import { useAuth } from '../../contexts/Auth';

function useMerchantId() {
  const { merchantId }: any = useAuth();

  return merchantId;
}

export { useMerchantId };
